<script setup lang="ts">
import {getNavLinks} from "~/scripts/navLinks";
import type {APIUser} from "~/types/user";

const route = useRoute()
const user = useUserStore()

const links = getNavLinks(user?.user as APIUser)

const isActive = (href: string) => href == '/' ? route.path == href : route.path.startsWith(href)
</script>

<template>
  <aside class="w-full" v-if="user.isLoggedIn">
    <div class="w-[220px] ml-auto mx-5 my-10">
      <ul class="my-3">
          <li v-for="link in links" :key="link.to">
            <NuxtLink
                :href="link?.to || '/'"
                class="transition px-4 py-2 rounded-lg hover:bg-gray-100 text-gray-700 hover:dark:bg-brand-500 dark:text-gray-300 text-lg flex items-center space-x-2 justify-center"
                :class="{'font-bold !text-indigo-400': isActive(link.to)}"
            >
              <NuxtImg v-if="link.image" :src="link.image" class="w-7 h-7 rounded-lg" />
              <Icon v-if="link?.iconActive && isActive(link.to)" :name="link.iconActive" />
              <Icon v-else-if="link?.icon" :name="link.icon" />
              <span>{{ $t(link.name) }}</span>
            </NuxtLink>
          </li>
      </ul>
      <LanguagePicker />
      <div class="mt-3">
        <div class="flex items-center space-x-2 text-sm">
          <NuxtLink href="/terms" class="transition-colors text-gray-700 dark:text-gray-400 hover:text-gray-600 dark:hover:text-gray-300">{{ $t('Terms') }}</NuxtLink>
          <NuxtLink href="/privacy" class="transition-colors text-gray-700 dark:text-gray-400 hover:text-gray-600 dark:hover:text-gray-300">{{ $t('Privacy') }}</NuxtLink>
        </div>
      </div>
    </div>
  </aside>
</template>